import { styled } from 'styled-components';

export const EventsGroup = styled.g`
    fill: coral;
`;
